import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import "./DashboardMenu.scss";

const DashboardMenu = () => {
  const options = [
    {
      name: "Institutions",
    },
    {
      name: "Accounts",
    },
    {
      name: "Assets",
    },
    {
      name: "Liabilities",
    },
    {
      name: "Credit Cards",
    },
    {
      name: "Long-Term Loans",
    },
  ];

  return (
    <>
      <div className="dashboard-menu-options">
        {options.map((option, i) => (
          <div key={i} className="option">
            {option.name}
          </div>
        ))}
      </div>
      <div className="dashboard-menu-search-container">
        <FontAwesomeIcon icon={faMagnifyingGlass} className="icon" />
      </div>
    </>
  );
};
export default DashboardMenu;
